import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Polygon, Marker, Popup, LayersControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";

// Define the Address type
interface Address {
  id: string;
  latitude: string | number;
  longitude: string | number;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  pinCode: string;
}

// Define the BoundaryData type
interface BoundaryData {
  latitude: number;
  longitude: number;
}

// Define the MapComponentProps type
interface MapComponentProps {
  addresses: Address[];
  boundaryData: BoundaryData[];
}

const PolygonBlockMap: React.FC<MapComponentProps> = ({ addresses, boundaryData }) => {
  const [key, setKey] = useState(0); // A state to force re-render the map container

  // Effect to reload the map when boundaryData or addresses change
  useEffect(() => {
    setKey((prevKey) => prevKey + 1); // Increment the key to force re-render
  }, [boundaryData, addresses]);

  // Default center: use the first boundary point if available, otherwise a fallback
  const defaultCenter: [number, number] =
    boundaryData.length > 0
      ? [boundaryData[0].latitude, boundaryData[0].longitude]
      : [9.9921, 76.3019];

  // Polygon positions: use boundaryData points
  const polygonPositions: [number, number][] = boundaryData.map(
    (point) => [point.latitude, point.longitude] as [number, number]
  );

  // Check if we have enough points to draw a polygon
  const showPolygon = polygonPositions.length >= 3;

  const handleMarkerClick = (lat: number, lng: number) => {
    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(googleMapsUrl, "_blank");
  };

  return (
    <div style={{ height: "535px", width: "100%" }}>
      {/* {/ {/ Use the key to forcefully recreate the MapContainer /} /} */}
      <MapContainer key={key} center={defaultCenter} zoom={50} style={{ height: "100%", width: "100%" }}>
      <LayersControl position="topright">
      <LayersControl.BaseLayer name="Default Map" checked>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="Satellite">
                <TileLayer
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                  attribution='&copy; Esri, Maxar, Earthstar Geographics, and the GIS User Community'
                />
              </LayersControl.BaseLayer>
            </LayersControl>

        {showPolygon && <Polygon positions={polygonPositions} color="blue" opacity={0.5} />}

        {/* {/ {/ Add Markers for Addresses /} /} */}
        {addresses.map((address) => (
          <Marker
            key={address.id}
            position={[Number(address.latitude), Number(address.longitude)]}
            eventHandlers={{
              click: () =>
                handleMarkerClick(Number(address.latitude), Number(address.longitude)),
            }}
          >
            <Popup>
              <div>
                <strong>Address:</strong> {address.addressLine1}, {address.addressLine2},{" "}
                {address.addressLine3}
                <br />
                <strong>Pin Code:</strong> {address.pinCode}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default PolygonBlockMap;
